import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import acceptLead from '../actions/AcceptLead';
import finishAcceptLead from '../actions/FinishAcceptLead';
import pick from '../tools/pick';
import exitIcon from '../../img/exit-icon.svg';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { ACCEPT_FAILED } from '../reducers/accepting-lead';

const currencySymbols = {
    USD: '$',
    GBP: '£',
};

function AcceptLeadButton({ lead, onConfirm, price, currency }) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { state, error } = useSelector(state => state.acceptingLead);

  const acceptLeadFromEvent = () => {
    dispatch(acceptLead(lead));
    // dispatch(finishAcceptLead(lead));
  };

  const toggleOpenState = () => setOpen(!open);

  const confirmed = () => {
    setOpen(false);
    if (onConfirm) onConfirm();
  };

  const confirmButton = () => (
    open ? <button onClick={acceptLeadFromEvent} type="button" className="accept-lead-btn btn btn--emphasis btn--block btn--primary">Confirm</button>
         : <button onClick={toggleOpenState} type="button" className="accept-lead-btn btn btn--emphasis btn--block btn--secondary">Accept Lead</button>
  );

  const tooltip = (action) => (
    open ? [
      <CSSTransition key="tooltip" classNames="slidein" timeout={{ enter: 200, exit: 300 }}>
        <div className="accept-lead-anchor">
          <div className="accept-lead-tooltip">
            <img className="accept-lead-exit-icon" onClick={toggleOpenState} src={exitIcon} alt="Exit icon"/>
            {action}
          </div>
        </div>
      </CSSTransition>
    ] : []
  );

  let action;
  let message;

  const formatPriceWithCurrency = (price, currency) => {
    const symbol = currencySymbols[currency] || ''; // Default to empty if not found
    return `${symbol}${price}`;
  };

  switch (state) {
    case ACCEPT_FAILED:
      message = pick(error, ['response', 'data', 'error'], 'Could not accept the lead');
      action = <div className="accept-lead-detail">{message}</div>;
      break;
    default:
      action = (
        <div>
          <div className="accept-lead-title">Accept Lead?</div>
          <div className="accept-lead-detail">
            This will be priced at {formatPriceWithCurrency(price, currency)}.
            <p>Your set budget is applicable to only criteria match leads, any leads purchased via close match will not contribute to your set budget and will be considered surplus to this.</p>
          </div>
        </div>
      );
      break;
  }

  return (
    <div className="accept-lead">
      <TransitionGroup>
        {tooltip(action)}
      </TransitionGroup>
      {confirmButton()}
    </div>
  );
}

export default AcceptLeadButton;
